import {Steps} from "../common/constants/constants";
import {useEffect} from "react";

interface Props {
    step: string,
}

const ConfirmedView = (props: Props) => {
    const {step} = props

    useEffect(() => {
        if (step === Steps.CONFIRMED) {
            setTimeout(() => window.scrollTo(0, 0), 100);
        }
    }, [step]);

    if (step !== Steps.CONFIRMED) {
        return null
    }

    return (
        <div className="p-repair-form__thanks-message">
            <p>Bedankt voor uw melding, u ontvangt binnen 24 uur bericht per e-mail.</p>
        </div>
    );
}
export default ConfirmedView
